export default function useFlagSingleton() {
  const urls: { [key: string]: URL } = {};
  const getFlagUrl = (language: string) => {
    const key = `flag-${language}`;
    if (!(key in urls)) {
      urls[key] = new URL(`/src/assets/images/Misc/flags/${language}.svg`, import.meta.url);
    }

    return urls[key];
  };

  const getFlag = (language: string) => {
    const flagExceptions = new Map([
      ['en', 'gb'],
      ['en-as', 'gb'],
      ['en-nd', 'gb'],
      ['es-br', 'es'],
      ['fr-bx', 'fr'],
      ['nl-bx', 'nl'],
    ]);

    const flag = flagExceptions.get(language.toLowerCase()) ?? language.split('-')[1].toLowerCase();

    return getFlagUrl(flag).href;
  };

  return {
    getFlag,
  };
}

const cached = useFlagSingleton();
export const useFlag = () => cached;
